import { Button } from '../../components/ui/button';
import { ArrowRight, Target } from 'lucide-react';

const HeroSection = ({ onStartQuiz }) => {
  return (
    <section className="relative min-h-screen lg:min-h-screen overflow-hidden bg-white" data-testid="hero-section">
      {/* Mobile Hero Photo Banner */}
      <div className="lg:hidden relative w-full h-[320px] mt-16">
        <img 
          src="https://customer-assets.emergentagent.com/job_00359606-ae4b-415a-b603-c3aa790ca59a/artifacts/qrjdo7t6_hero02%281%29.jpg"
          alt="Étudiants africains partis en Allemagne avec Speak &amp; Move"
          className="w-full h-full object-cover object-[center_25%]"
        />
        {/* Bottom gradient fade to white */}
        <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-white to-transparent" />
      </div>

      <div className="lg:grid lg:grid-cols-2 lg:min-h-screen">
        {/* Left - Content Column */}
        <div className="relative z-10 flex items-center px-4 sm:px-6 lg:px-12 xl:px-16 py-8 lg:py-0 lg:pt-28">
          <div className="w-full max-w-xl mx-auto lg:mx-0 lg:ml-auto lg:mr-12 mt-8 lg:mt-0">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary/10 text-primary text-sm font-medium mb-10">
              <span className="w-2 h-2 rounded-full bg-primary animate-pulse" />
              Inscriptions ouvertes — Places limitées
            </div>
            
            <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight mb-6">
              Votre rêve Allemand prend vie ici{' '}
              <span className="text-primary">: de 0 à erfolgreich!</span>
            </h1>
            
            <p className="text-lg sm:text-xl text-gray-600 mb-4 max-w-xl">
              Formation intensive + dossier visa + accompagnement complet.<br />
              <span className="font-semibold text-gray-900">Votre succès, Notre priorité !</span>
            </p>

            {/* Mini testimonial */}
            <div className="flex items-center gap-3 mb-8 p-4 bg-gray-50 rounded-xl max-w-md">
              <img 
                src="https://customer-assets.emergentagent.com/job_515c4a64-eec4-4be1-ae71-705e6633de80/artifacts/mylrthxt_medium-shot-friends-outdoors.jpg" 
                alt="Fatou D."
                className="w-12 h-12 rounded-full object-cover border-2 border-primary"
              />
              <div className="flex-1">
                <p className="text-sm text-gray-600 italic">"J'étais vendeuse à Douala, aujourd'hui je suis infirmière à Munich"</p>
                <p className="text-xs text-gray-500 font-medium">— Fatou M., arrivée en 2023</p>
              </div>
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-col gap-4">
              {/* Primary CTA - Dominant */}
              <Button 
                size="lg" 
                onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
                className="bg-primary hover:bg-primary text-white text-lg px-8 py-5 rounded-full shadow-[0_8px_24px_rgba(204,0,126,0.35)] hover:shadow-[0_12px_32px_rgba(204,0,126,0.45)] hover:scale-[1.03] transition-all duration-300 w-full sm:w-auto"
                data-testid="hero-cta-primary"
              >
                Démarrer mon projet vers l'Allemagne
                <ArrowRight className="w-5 h-5 ml-2" />
              </Button>
              
              {/* Quiz CTA */}
              <Button 
                size="lg" 
                variant="outline"
                onClick={onStartQuiz}
                className="bg-white text-secondary border-2 border-secondary text-lg px-8 py-5 rounded-full hover:bg-secondary hover:text-white hover:border-secondary transition-all duration-300 w-full sm:w-auto"
                data-testid="hero-cta-quiz"
              >
                <Target className="w-5 h-5 mr-2" />
                Tester mon niveau gratuitement
              </Button>
              
            </div>

            {/* Stats */}
            <div className="flex items-center justify-center sm:justify-start gap-6 sm:gap-8 mt-10 pt-8 border-t border-gray-100">
              <div className="text-center">
                <p className="font-heading text-2xl sm:text-3xl font-bold text-secondary">45</p>
                <p className="text-xs sm:text-sm text-gray-500">Étudiants depuis 2023</p>
              </div>
              <div className="w-px h-10 sm:h-12 bg-gray-200" />
              <div className="text-center">
                <p className="font-heading text-2xl sm:text-3xl font-bold text-secondary">94%</p>
                <p className="text-xs sm:text-sm text-gray-500">Visas approuvés</p>
              </div>
              <div className="w-px h-10 sm:h-12 bg-gray-200" />
              <div className="text-center">
                <p className="font-heading text-2xl sm:text-3xl font-bold text-secondary">5</p>
                <p className="text-xs sm:text-sm text-gray-500">Partis ce semestre</p>
              </div>
            </div>
          </div>
        </div>

        {/* Right - Full Bleed Photo Column (Desktop only) */}
        <div className="hidden lg:block relative">
          {/* Full bleed photo */}
          <div className="absolute inset-0 top-0">
            <img 
              src="https://customer-assets.emergentagent.com/job_00359606-ae4b-415a-b603-c3aa790ca59a/artifacts/qrjdo7t6_hero02%281%29.jpg"
              alt="Étudiants africains partis en Allemagne avec Speak &amp; Move"
              className="w-full h-full object-cover object-[center_20%]"
            />
            {/* Left gradient fade into white content */}
            <div className="absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-white to-transparent" />
            {/* Bottom gradient fade to white */}
            <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-white to-transparent" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
